/*
 * Jira Ticket:
 * Created Date: Wed, 11th Mar 2020, 16:54:04 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { TextInput } from 'react-admin';
import { tabbedFilters } from 'styles';

const ProjectFilters = props => {
  const classes = tabbedFilters();
  const { setFilters } = props;

  return (
    // Note: we do not use the Filters component here as we would
    // be hitting errors nesting forms inside forms
    <div className={classes.root}>
      <TextInput
        source="projectName"
        label={'resources.Project.fields.project'}
        onChange={value => setFilters(value)}
        options={{ resettable: true }}
      />
    </div>
  );
};

export default ProjectFilters;
